<template>
    <div class="override_settings">
        <div>
            <yes_no
                key="OVERRIDE_LOCATION_SETTINGS"
                title="OVERRIDE_LOCATION_SETTINGS"
                @input="on_change_value('can_override')"
                v-model="can_be_override"
            >
            </yes_no>
        </div>

        <div class="pos_settings p-2" v-if="can_be_override">
            <div class="form-group" v-for="(key_val,key_name) in basic_params" v-if="key_name.length > 0 && is_text_field(key_name)">
                <info_field
                    :f_uniq="key_name"
                    :f_type="key_name"
                    @change="on_change_value(key_name)"
                    :f_title="__t(key_name.toUpperCase())"
                    :is_disabled=false
                    :f_val="basic_params[key_name]"
                    v-model=basic_params[key_name]
                >
                </info_field>
            </div>

            <div class="form-group row" >
                <div class="col-lg-4 col-sm-4 col-md-4 col-xs-12 mb-3" v-for="(key_val,key_name) in basic_params" v-if="key_name.length > 0 && !is_text_field(key_name) && key_name != 'id'">

                    <div class="form-group mt-2" v-if="key_name == 'percent_type'">
                        <label class="form-label">
                            {{__t('PERCENT_TYPE')}}
                        </label>

                        <div class="input-group flex-nowrap">
                            <b-form-radio-group
                                id="btn-radios-1"
                                @update="on_change_value(key_name)"
                                v-model="basic_params[key_name]"
                                button-variant="outline-primary"
                                :options="[
                                  { text: __t('PERCENT_LABEL'), value: 'percent' },
                                  { text:  __t('FIXED'), value: 'fixed' }
                            ]"
                                name="radios-btn-default"
                                buttons
                            ></b-form-radio-group>
                        </div>
                    </div>

                    <yes_no
                        v-else
                        :key="key_name"
                        :title="key_name"
                        @input="on_change_value(key_name)"
                        v-model="basic_params[key_name]"
                    >
                    </yes_no>
                </div>
            </div>
        </div>

        <div class="exclude_categories mt-4">

            <label class="form-label">
                {{__t('IGNORE_CATEGORIES_PERCENT_PRICE')}}
            </label>

            <v-select multiple v-model="ignore_categories"
                      @search="onSearch"
                      @input="push_reason_str"
                      class="imc_reasons"
                      label="title"
                      key="id"
                      :filterable="true"
                      :options=categories  >
            </v-select>
        </div>

    </div>

</template>


<script>

import vSelect from 'vue-select';
import {createHelpers} from "vuex-map-fields";
import yes_no from "../../../../sys/radio/yes_no.vue";
import Info_field from "../../../../sys/info_field.vue";


const {mapFields} = createHelpers({
    getterType: 'aggregator/getAggregatorStateField',
    mutationType: 'aggregator/updateAggregatorStateField',
});

export default {
    name: "location_override",
    components: {
        Info_field,
        yes_no,
        vSelect
    },

    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            categories : [],
        }
    },

    methods: {

        push_reason_str(val) {
            this.location.ignore_categories = val;
        },

        onSearch(search, loading) {
            if(search.length > 2) {
                loading(true);
                this.search(loading, search);
            }
        },

        async search(loading, search)  {
            await api.post('/internal/v1/catalog/categories',{
                "org_id" : this.location.parent_id,
                "provider_filter" : this.location.provider,
                'search' : search
            }).then(({data}) => {
                loading(false);
                this.categories =[];
                if(data.status == "operation_success") {
                    this.categories = data.data;
                }

            }).catch(err => {
                this.categories =[];
                loading(false);
            });
        },

        is_valid_key(key_name) {
            return true;
        },

        is_text_field(key_name) {
            if(this.params_type.hasOwnProperty(key_name)) {
                if(key_name == 'percent_type') {
                    return false;
                }

                if(key_name == 'provider_id') {
                    return false;
                }

                let cur_type = this.params_type[key_name];
                return cur_type === 'string';
            }

            return !(key_name === 'id');
        },

        on_change_text_value(key_name,key_val) {
            if (this.basic_params.hasOwnProperty(key_name)) {
                this.basic_params[key_name] = key_val;
                this.on_change_value(key_val);
            }
        },

        on_change_value(key_name) {
            if(key_name == 'can_override') {
             //   this.can_be_override = !this.can_be_override;
            }

            if (this.basic_params.hasOwnProperty(key_name)) {
                this.$emit('on_change_overrides', {
                    'key_name': key_name,
                    'key_val': this.basic_params[key_name],
                    'key_type': "overrides",
                })
            }
        },
    },

    computed: {

        ...mapFields([
            'aggregator_item'
        ]),

        ignore_categories : {
            get: function () {
                if(this.location.hasOwnProperty("ignore_categories")) {
                    return this.location.ignore_categories;
                }

                return [];
            },
            set: function (newValue) {
                this.location.ignore_categories = newValue;
            }
        },

        can_be_override: {
            get: function () {
                return this.location.overrides.is_enable;
            },

            set: function (newValue) {
                this.location.overrides.is_enable = newValue;
            }
        },

        basic_params() {
            return this.location.overrides.fields;
        },

        params_type() {
            return this.location.overrides.types;
        },

    },
}
</script>



<style scoped>

</style>
